import { useState, useEffect } from "react";
import Button from "../Buttons/Button";

const ColorPicker = ({ id, label = null, action = null, initialColor = null }) => {
    const [selectedColor, setSelectedColor] = useState(initialColor || null);

    const presetColors = [
        '#F7C1C1', // rot, hell
        '#B5D4F4', // blau, hell
        '#9FE1CB', // teal, hell
        '#F5C4B3', // koralle, hell
        '#FAC775', // amber, hell
        '#F4C0D1', // pink, hell
        '#C0DD97', // grün, hell
        '#CECBF6', // lila, hell
        '#D3D1C7', // grau, hell
        '#B4E4D9', // mint, hell
        '#F6D9A0', // sand, hell
        null
    ];

    useEffect(() => {
        setSelectedColor(initialColor);
    }, [initialColor]);

    function handleColorChange(color) {
        setSelectedColor(color);
        if (action) {
            action(color)
        }
    }

    return (
        <div>
            {label && <label htmlFor={id} className="block text-lg font-medium text-gray-700 mb-2">
                {label}
            </label>}

            <div className="grid grid-cols-6 gap-2">
                {presetColors.map((color) => (
                    <Button
                        key={color}
                        buttonColor=""
                        onClickAction={() => handleColorChange(color)}
                        borderStyle={selectedColor === color ? "border-4 rounded-md border-black" : "border rounded-md border-gray-300"}
                        classNames="w-10 h-10"
                        style={{ backgroundColor: color }}
                    />
                ))}
            </div>
        </div>
    )
}

export default ColorPicker